<template>
  <div class="overlay" v-show="showPreview">
    <div class="overlay_inner preview_notification">

      <p class="note" v-translate>Náhled oznámení</p>

      <div class="responsiveTabs r-tabs">

        <ul class="tabs">
          <li :class="getActiveTabClass('settings', false)">
            <a @click.prevent.stop="activateTab('settings', false)">Detail oznámení</a>
          </li>
          <li :class="getActiveTabClass('notification', false)">
            <a @click.prevent.stop="activateTab('notification', false)">Notifikace</a>
          </li>
        </ul>

        <div class="tabs_content" v-show="isActiveTab('settings', false)">
          <div class="preview_notification_content">

            <div id="zpravy" class="main-wrapper">

              <div class="message_body">
                <div class="title">{{ previewData.subject }}</div>
                <div class="message_body_inner">
                  <div class="date">24. 8.</div>
                  <div class="message_type">{{ type }}</div>
                  <div class="short_text">
                    {{ previewData.short_body }}
                  </div>
                  <div class="message_image" v-if="previewData.image">
                    <img :src="previewData.image" :alt="type">
                  </div>
                  <div class="main_text" v-html="previewData.body" />
                </div>
              </div>

              <div class="actions" v-if="!isAdvertisingBanner">
                <a class="actions__item focus">/</a>
              </div>

              <div class="qr_code" v-if="isAdvertisingBanner && previewData.qr_code_src">
                <img :src="previewData.qr_code_src" alt="QR kód" />
              </div>
              <div class="message_image" v-if="previewData.image">
                <img :src="previewData.image" :alt="type">
              </div>

              <div class="actions" v-if="isAdvertisingBanner">
                <a class="actions__item actions__item--main focus">Ĉ <span class="btn-label" v-translate>Koupit</span></a>
                <a class="actions__item">/</a>
              </div>

            </div>

          </div>
        </div>

        <div class="tabs_content" v-show="isActiveTab('notification', false)">

          <div class="preview_notification_content">

            <div class="main-wrapper">

              <div class="message_overlay">
                <div class="message_popup" :class="{'ad_message_popup': previewData.image}">

                  <div v-if="isAdvertisingBanner" class="message_popup_box focus">
                    <div class="message_image" v-if="previewData.image">
                      <img :src="previewData.image" :alt="type">
                    </div>
                    <div class="message_content">
                      <div class="message_header">{{ previewData.subject }}</div>
                    </div>
                    <div class="message_counter">25 s</div>
                  </div>

                  <div v-if="!isAdvertisingBanner" class="message_popup_box focus">
                    <div class="message_state new">N</div>
                    <div class="message_content">
                      <div class="message_header">{{ previewData.subject }}</div>
                      <div class="message_type">{{ type }}</div>
                    </div>
                    <div class="message_counter">25 s</div>
                  </div>

                  <div class="buttons">
                    <div class="btn close">/</div>
                  </div>
                </div>
              </div>

            </div>

          </div>

        </div>
      </div>

      <a class="btn btn_action btn_close" title="Zavřít" @click.stop="hidePreview">Zavřít</a>
    </div>
  </div>
</template>

<script>

import tabs from "../../../mixins/tabs";

export default {
  name: 'PreviewPopup',
  mixins: [tabs],
  props: {
    previewData: Object,
    isAdvertisingBanner: {
      type: Boolean,
      default: false
    },
    showPreview: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    hidePreview() {
      this.$emit('hide-preview')
    }
  },
  computed: {
    type() {
      const types = [
        {id: 'info', text: this.$gettext('Informativní sdělení')},
        {id: 'maintenance_info', text: this.$gettext('Servisní informace')},
        {id: 'new_service', text: this.$gettext('Nová služba')},
        {id: 'fault', text: this.$gettext('Porucha')},
        {id: 'maintenance', text: this.$gettext('Servis')},
        {id: 'billing', text: this.$gettext('Platby')},
      ]
      let type = types.find(o => o.id === this.previewData.type)
      return (type && type.hasOwnProperty("text")) ? type.text : this.previewData.type
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/messages/popup/PreviewPopup.vue